import { render } from "./loaderWithOverlay.vue?vue&type=template&id=1869e4fa"
import script from "./loaderWithOverlay.vue?vue&type=script&lang=js"
export * from "./loaderWithOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__